import React from "react"
import { Skeleton } from "antd"

type Props = {
  variant: "rostered" | "anyday"
}

const CreateShiftPlanTablesSkeleton: React.FC<Props> = ({ variant }) => {
  if (variant === "rostered") {
    return (
      <>
        <Skeleton.Input
          active
          size="small"
          className="!w-32 !min-w-0 mb-2"
        />
        <div className="rounded-lg border-2 border-[#E2E8F0] p-4 space-y-4">
          <div className="flex gap-2">
            <Skeleton.Avatar active size="small" shape="square" />
            <div className="flex-1 grid grid-cols-7 gap-2">
              {Array.from({ length: 14 }).map((_, i) => (
                <Skeleton.Input
                  key={i}
                  active
                  size="small"
                  className="!w-full !min-w-0"
                />
              ))}
            </div>
          </div>
          <div className="flex gap-2">
            <Skeleton.Avatar active size="small" shape="square" />
            <div className="flex-1 grid grid-cols-7 gap-2">
              {Array.from({ length: 14 }).map((_, i) => (
                <Skeleton.Input
                  key={i}
                  active
                  size="small"
                  className="!w-full !min-w-0"
                />
              ))}
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Skeleton.Input active size="small" className="!w-32 !min-w-0 mb-2" />
      <div className="rounded-lg border-2 border-[#E2E8F0] p-4 space-y-4">
        <div className="flex gap-2 items-center mb-4">
          <Skeleton.Button active size="small" />
          <Skeleton.Input
            active
            size="small"
            className="!flex-1 !min-w-0"
          />
          <Skeleton.Input
            active
            size="small"
            className="!w-[160px] !min-w-0"
          />
        </div>
        <div className="grid grid-cols-[32px_200px_1fr_auto] gap-4 items-center py-3 border-b border-[#E2E8F0]">
          <Skeleton.Avatar active size="small" shape="square" />
          <Skeleton.Input active size="small" className="!w-full !min-w-0" />
          <Skeleton.Input active size="small" className="!w-full !min-w-0" />
          <Skeleton.Input
            active
            size="small"
            className="!w-24 !min-w-0 shrink-0"
          />
        </div>
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="grid grid-cols-[32px_200px_1fr_auto] gap-4 items-center py-3 border-b border-[#E2E8F0]"
          >
            <Skeleton.Avatar active size="small" shape="square" />
            <Skeleton.Input active size="small" className="!w-full !min-w-0" />
            <Skeleton.Input active size="small" className="!w-full !min-w-0" />
            <Skeleton.Input
              active
              size="small"
              className="!w-24 !min-w-0 shrink-0"
            />
          </div>
        ))}
      </div>
    </>
  )
}

export default CreateShiftPlanTablesSkeleton

